export const ORDERLINE_STATES = {
  NEW: 'NEW',
  PAID: 'PAID',
  VALIDATED: 'VALIDATED',
  SHIPPED: 'SHIPPED',
  CANCELLED: 'CANCELLED',
  REFUNDED: 'REFUNDED',
  NOT_PAID: 'NOT_PAID',
  REPLACED: 'REPLACED',
  REFUNDED_PRE_DELIVERY: 'REFUNDED_PRE_DELIVERY',
  REFUNDED_POST_DELIVERY: 'REFUNDED_POST_DELIVERY',
  PENDING: 'PENDING',
  ON_HOLD: 'ON_HOLD',
} as const

export type OrderlineStates =
  (typeof ORDERLINE_STATES)[keyof typeof ORDERLINE_STATES]
